<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <p>Document Number : {{docNo}}</p>
    <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="">
    <div class="row sche-doc-head eip-mt-20 eip-ml-xs-10 eip-mr-xs-10">
    <div class="row reset-row d-flex  flex-grow-1">
      <div class="d-flex eip-p-10  p-10">
        <!-- <button class="btn btn-primary eip-ml-10 mr-2" id="btnViewAll" (click)="viewAll()">View All</button>
        <button class="btn btn-primary eip-ml-10 mr-2" id="btnSelected" (click)="filterSelected()">View
          Selected</button> -->
      </div>
    </div>
  </div>
  <div class="row eip-mt-20 eip-ml-xs-10 eip-mr-xs-10">
    <div class="col-xl-12 col-lg-12 col-md-12 p-10">
      <kendo-grid #tqGrid [kendoGridBinding]="tenderlist" [sortable]="true" [resizable]="true"
         [reorderable]="true"  
         [pageSize]="15" [pageable]="true" [selectable]="true" 
        (selectionChange)="onSelectionChange($event)">
        <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
            <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
        </ng-template>
        <!-- <kendo-grid-checkbox-column showSelectAll="true" field="isSelected" width="30">

          <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" [(ngModel)]="dataItem.isSelected" />
        </ng-template>
        </kendo-grid-checkbox-column> -->

        <kendo-grid-column *ngFor="let stage of elementsList" title="{{stage.tE_Description}}" width="100">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [innerHTML]="getItemData(dataItem,stage)"></span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Over All Tender Qty" width="170">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [innerHTML]="dataItem.tenderElementDetails[0].quantity"></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Released DWG Tender Qty" width="170">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [innerHTML]="dataItem.releasedDwgPlannedQty"></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Released DWG Actual Qty" width="170">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [innerHTML]="dataItem.releasedDwgActualQty"></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="DWG. Wise  Tender Qty" width="170">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [innerHTML]="dataItem.dwgPlannedQty"></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="DWG. Wise Actual Qty" width="170">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <mat-form-field>
              <input matInput  numeric decimals="2" type="number" placeholder="" [disabled]="isReadMode" [(ngModel)]="dataItem.actualQty" required>
            </mat-form-field>
          </ng-template>

        </kendo-grid-column>
        <kendo-grid-column title="Remarks" width="170">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <mat-form-field>
              <input matInput type="text" [(ngModel)]="dataItem.remarks" [disabled]="isReadMode">
            </mat-form-field>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>

</div>
<div mat-dialog-actions>
  <div class="row reset-row d-flex justify-content-end flex-grow-1">
    <div class="d-flex eip-p-10">
      <button class="btn btn-primary eip-ml-10 mr-2" id="btnSave" *ngIf="!isReadMode" (click)="saveTenderWF('INSERT')">Save</button>
      <button class="btn btn-primary eip-ml-10 mr-2" id="btnSubmit" *ngIf="!isReadMode"  (click)="saveTenderWF('SUBMIT')">Submit</button>
      <!-- *ngIf="isTenderQuantityApprovalRequired == true" -->
      <button class="btn btn-primary eip-ml-10 mr-2"    id="btnApprove" (click)="saveTenderWF('APPROVE')">Approve</button>
      <!-- <button class="btn btn-primary eip-ml-10 mr-2" id="btnRevert" >Revert</button> -->
    </div>
  </div>
</div>